import { redirect } from 'react-router'
import { UserType } from '~/api/__generated-types__'
import { ROUTES } from '~/routes-typed'

export const specialCharsRegEx = /[!@#$%^&*(),.?":{}|<>]/

export const PASSWORD_RULES = [
  { label: 'min. 12 Zeichen', test: (p: string) => p.length >= 12 },
  { label: 'min. 1 Großbuchstabe', test: (p: string) => /[A-Z]/.test(p) },
  { label: 'min. 1 Kleinbuchstabe', test: (p: string) => /[a-z]/.test(p) },
  { label: 'min. 1 Zahl', test: (p: string) => /[0-9]/.test(p) },
  {
    label: 'min. 1 Sonderzeichen',
    test: (p: string) => specialCharsRegEx.test(p),
  },
]

/**
 * Takes an arbitrary value and returns the integer representation of it
 * or undefined inf the conversion fails
 */
export const cleanInt = (value: unknown): number | undefined => {
  if (Number.isInteger(value)) {
    return value as number
  }
  if (value && typeof value === 'string') {
    const parsed = parseInt(value)
    if (!isNaN(parsed) && Number.isInteger(parsed)) {
      return parsed
    }
  }
  return undefined
}

export const isSafeRedirect = (url: string) => {
  // Must start with a single slash (internal path)
  // Not allow double slashes (protocol-relative)
  return url.startsWith('/') && !url.startsWith('//')
}

export const pageGuardian = (
  userInfo?: UserType,
  headers?: HeadersInit | undefined,
) => {
  if (!userInfo) {
    throw redirect(ROUTES.AUTH.LOGIN.$buildPath({}))
  }

  // Check if user needs to accept data privacy consent
  if (!userInfo?.dataPrivacyConsentAt) {
    const dataPrivacyRoutePath = ROUTES.DATA_PRIVACY.$buildPath({})
    throw redirect(dataPrivacyRoutePath, { headers })
  }

  throw redirect(ROUTES.CHOOSE_SERVICE.$buildPath({}), { headers })
}
